"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var PriceImpactProductReport_1 = require("./PriceImpactProductReport");

var Impact_1 = require("./Impact");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");
/**
 * Information of price impact about specific release.
 *
 * @author Michal Sevcenko
 */


var PriceImpactReport =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceImpactReport, _DomainObject_1$Domai);

  /**
   * ctor
   *
   * @param releaseId identifier of the release
   * @param diffDays number of days in the interection of requested time interval, and the validity of the release
   * @param overflow true indicates that requested time interval exceeds beyond ydg forecast validity
   * @param products list of products and their sales volume real impact
   * @param salesVolumeImpact total real and expected sales volume, and their impact
   * @param bmImpact BM average weighted by real and expected volumes as weights, and impact thereof
   * @param revenueImpact revenue average weighted by real and expected volumes as weights, and impact thereof
   * @param profitImpact profit average weighted by real and expected volumes as weights, and impact thereof
   * @param products sales volume impact on product level
   */
  function PriceImpactReport(releaseId, diffDays, overflow, salesVolumeImpact, bmImpact, revenueImpact, profitImpact, release, products) {
    var _this;

    _classCallCheck(this, PriceImpactReport);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceImpactReport).call(this));
    _this.releaseId = releaseId;
    _this.diffDays = diffDays;
    _this.overflow = overflow;
    _this.salesVolumeImpact = salesVolumeImpact;
    _this.bmImpact = bmImpact;
    _this.revenueImpact = revenueImpact;
    _this.profitImpact = profitImpact;
    _this.release = release;
    _this.products = products;
    return _this;
  }

  return PriceImpactReport;
}(DomainObject_1.DomainObject);

exports.PriceImpactReport = PriceImpactReport;

PriceImpactReport.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceImpactReport.name);
  return {
    releaseId: builder.str('releaseId'),
    diffDays: builder.num('diffDays'),
    overflow: builder.opt(builder.bool('overflow')),
    salesVolumeImpact: builder.opt(builder.obj('salesVolumeImpact', Impact_1.Impact.schema, Impact_1.Impact.ctor)),
    bmImpact: builder.opt(builder.obj('bmImpact', Impact_1.Impact.schema, Impact_1.Impact.ctor)),
    revenueImpact: builder.opt(builder.obj('revenueImpact', Impact_1.Impact.schema, Impact_1.Impact.ctor)),
    profitImpact: builder.opt(builder.obj('profitImpact', Impact_1.Impact.schema, Impact_1.Impact.ctor)),
    release: builder.opt(builder.obj('release', null, null)),
    products: builder.opt(builder.listOf(builder.obj('products', PriceImpactProductReport_1.PriceImpactProductReport.schema, function (mat) {
      return new PriceImpactProductReport_1.PriceImpactProductReport(mat.productId, mat.salesVolumeImpact, mat.marginImpact, mat.revenueImpact, mat.profitImpact);
    })))
  };
}();